import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';

export const globalStyles = (theme: Theme) => css({
  html: {
    height: '100%',
    minHeight: '100%',
  },
  body: {
    padding: 0,
    margin: 0,
    fontFamily: '"Work Sans", sans-serif',
    fontStyle: 'normal',
    fontWeight: 500,
    height: '100%',
    minHeight: '100%',
    color: theme.textColors.primary,
    background: theme.backgroundColors.primary,
  },
  button: {
    outline: 'none',
    fontFamily: 'inherit',
    fontWeight: 'inherit',
  },
  '.root': {
    height: '100%',
  },
});
